function fetchLosicaProducts() {

    const codes = [];

    // Detail produktu:
    // <span data-micro="sku">81186</span>
    $('[data-micro="sku"]').each(function () {
        const code = $.trim($(this).text());

        if (code) {
            codes.push(code);
        }
    });

    // Košík:
    // .cart-items .cart-item[data-micro="cartItem"]
    // atribut data-micro-sku
    $('.cart-items .cart-item[data-micro="cartItem"]').each(function () {
        const code = $.trim(
            $(this).attr('data-micro-sku') || ''
        );

        if (code) {
            codes.push(code);
        }
    });

    // kódy, které už máme z předchozího volání (jiná stránka výpisu, dotažené produkty apod.)
    const knownCodes = (window.losicaProducts || []).map(function (product) {
        return String(product.code);
    });

    // odstranění duplicit a už známých kódů
    const uniqueCodes = [...new Set(codes)].filter(function (code) {
        return !knownCodes.includes(code);
    });

    // i když nejsou žádné nové kódy k dotažení, DOM se mohl mezitím přerenderovat
    // (řazení, stránkování) - proto je potřeba znovu aplikovat už známá data
    if (typeof applyProductsQuantityData === "function") {
        applyProductsQuantityData();
    }

    if (typeof applyPersonalCollectionOnlyShipping === "function") {
        applyPersonalCollectionOnlyShipping();
    }

    if (!uniqueCodes.length) {
        return;
    }

    $.ajax({
        url: 'https://php.shopcode.cz/api/losica/api-code.php',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',

        data: JSON.stringify({
            codes: uniqueCodes
        }),

        success: function (response) {

            if (!response.success) {
                console.error('Losica API chyba:', response);
                return;
            }

            console.log('Losica produkty:', response.products);
            console.log('Nenalezené:', response.not_found);

            window.losicaProducts = (window.losicaProducts || []).concat(response.products);

            if (typeof applyProductsQuantityData === "function") {
                applyProductsQuantityData();
            }

            if (typeof applyPersonalCollectionOnlyShipping === "function") {
                applyPersonalCollectionOnlyShipping();
            }
        },

        error: function (xhr, status, error) {
            console.error(
                'Losica AJAX chyba:',
                status,
                error,
                xhr.responseText
            );
        }
    });

}

$(fetchLosicaProducts);
document.addEventListener("ShoptetDOMPageContentLoaded", fetchLosicaProducts);
document.addEventListener("ShoptetPageSortingChanged", fetchLosicaProducts);
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", fetchLosicaProducts);
document.addEventListener("ShoptetDOMContentLoaded", fetchLosicaProducts);

/*
{
    "code": "97974",
        "decimalCount": 1, //počet desetiných míst, potřebujete to pro to tlačítko .quantity input
            "minimumAmount": 3.5, //minimální objednatelné množství. Využijeme na nákup po násobcích viz detail produktu když přidáváte a odebíráte množství. Stačí jenom upravit to tlačítko pro změnu množství na výpise a je to.
                "productNumber": null //když je null nic ale když je to MO zákazník a hodnota pole je ANO tak se v košíku musí zbýt jenom možnost osobního odběru
}
*/
